// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AntiTrackYellowIcon, responsive } from '../../components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  position: absolute;
  background: var(--nll-white);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 9.625rem 1.5625rem 1.5625rem;

  ${responsive.tablet`
    padding: 3.75rem 20% 20%;
    `}

  ${responsive.mobile`
    padding: 3.75rem 1.5625rem 1.5625rem;
  `}
`;

const InputContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  border-radius: 1.875rem;
  background: var(--nll-white);
  border: 0.125rem solid var(--nll-gray01);
  font-size: 1rem;
  margin: 0.3125rem 0 1.5625rem 0;
`;

const Button = styled.button`
  border-radius: 1.875rem;
  border: 0.125rem solid var(--nll-gray01);
  background: var(--nll-yellow);
  margin: -0.125rem;
  padding: 0 1rem;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0rem;
  color: var(--nll-gray01);
`;

const Input = styled.input`
  border: none;
  border-radius: 1.875rem;
  padding: 0.8125rem 0.125rem 0.8125rem 1rem;
  text-overflow: ellipsis;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: -0.0188rem;
  flex: 1;
  user-select: none;
  pointer-events: none;
`;

const Instructions = styled.h1`
  font-size: 1.75rem;
  line-height: 2.125rem;
  letter-spacing: -0.018rem;
`;

const Disclaimer = styled.p`
  color: var(--nll-gray02);
`;

export const BrowserNotSupported = () => {
  const { t } = useTranslation();
  const [buttonText, setButtonText] = useState('Copy link');

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.origin);
    setButtonText('Copied!');
  };

  return (
    <Container>
      <AntiTrackYellowIcon />
      <Instructions>{t('OnboardInstructions')}</Instructions>
      <InputContainer>
        <Input type='text' value={window.location.origin} readOnly />
        <Button data-testid='copyLink' onClick={copyToClipboard}>
          {t(buttonText)}
        </Button>
      </InputContainer>
      <Disclaimer>{t('OnboardDisclaimer')}</Disclaimer>
    </Container>
  );
};
